import {levels} from '../helpers'

# basic list of predefined filters
const filters = {
	short: do(item) 3600 > item.casts_duration
	medium: do(item) 10800 > item.casts_duration >= 3600
	long: do(item) item.casts_duration >= 10800
	paid: do(item) item.access == 'members'
	free: do(item) item.access == 'users' or item.access == 'guests'
}

const topics = {
	'': 'All Topics'
	html: 'HTML'
	css: 'CSS'
	javascript: 'Javascript'
	react: 'React'
	popular: 'Popular'
	ai: 'Artificial Intelligence'
	other: 'Other'
}

const durations = {
	'': 'All Durations'
	short: 'Short (<1hr)'
	medium: 'Medium (1-3hr)'
	long: 'Long (>3hr)'
}

const prices = {
	'': 'Free and Paid'
	free: 'Free'
	paid: 'Paid'
}

tag allcourses-page

	css .all-courses h:>800px bg:$light-moss px: 2.5rem
	css .filter-wrapper m:10px 0 js:flex-start grid-area:f
	css .tiles
		pos:relative
		grid-area:c
		$cols:1 @570:2 @880:3 @1350:5
		p@lt-sm:0
	css .nomatch h:100% d:flex jc:center ai:center
	css .filter-toggle
		px:6 py:4
		d:hflex j:center rd:lg cursor:pointer us:none
		@hover td:underline

	css .permanent-query-container
		d:vflex @sm:hflex
		jc:flex-start
		# max-width:980px
		m:0 @sm:5 5 1 5
		bg:transparent

	css .neutral-button
		# Brought from .button - could be extended better
		d:hflex j:center rd:lg cursor:pointer us:none
		px:6 py:4
		w:max-content mx:auto
		tt:capitalize td:none fs:1.25rem/1.4 @page-scrim:1rem/1.4 fw:bold ff:inherit ws:nowrap td:none @hover:none
		tween:all 0.1s ease-out
		bg:transparent
		@hover bxs:0px 2px 40px 0px rgba(0,0,0,0.3) y:-3px
		@active bxs:none y:0
		max-height:16

	css .toggled-parent
		ac:center
		ai:center
		mb:8

	css .toggled-query-container
		d:vflex @lg:hflex
		ja:center
		p:3 7
		m@sm:7
		rd:2
		bg:white
		box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.3)
		max-width:max-content

	css .reset-filters
		d:hflex
		a:center
		bg:$light-lemony
		cursor:pointer
		p:2.5 3
		rd:3
		bd: 1px solid
		fw:bold
		max-width:max-content
		max-height:16

	css .search-box d:flex fld:column mb:20px
		>> input  p:10px 20px  bd:0.3px solid rd:3px
	css .checkbox-field 
		d:flex ai:center
		>> input mr:0.5rem scale:scale(1.5)

	css .ss-select
		d:flex
		jc:center 
		rd:2
		m:2
		bd: 1px solid
		bg:transparent .selected:white
		>> select
			cursor:pointer
			fs:16px
			fw:bold
			bd:none
			d:block
			appearance:none
			p:14px 50px 14px 26px
			rd:4px
			box-shadow:0px 1px 4px rgba(0, 0, 0, 0.15)
			bg:url("/static/art/dropdown_arrow.svg") no-repeat 85% center
			bgc:white
			focus@outline:none

	css .content
		min-width:100% @570:40vw @880:min-content
		p:0 2

		>> h4 m: 0 2
		>>  .ss-select
			>> select width: 100%
	
	css	.dropdown background:url('/static/art/dropdown_arrow.svg') no-repeat right background-position:right 8% bottom 50% -webkit-appearance:none

	css .topics
		d:hflex
		ja:flex-start
		flw:wrap

	css .topic
		d:hflex
		ja: center
		p:5 5
		h:9
		rd:2
		m:2
		bd: 1px solid
		box-sizing: border-box
		bg:transparent .selected:white
		ws:nowrap
		fw:bold

	css only-wide d:none @880:block

	prop showFilters? = no

	get query do store.query

	#courses = null
	get courses do
		#courses ||= store.courses
		const {level,price,duration,topic} = query
		return #courses unless level or price or duration or topic

		#courses.filter do
			if level and $1.level != level
				return no

			if filters[price] and filters[price]($1) == no
				return no

			if filters[duration] and filters[duration]($1) == no
				return no

			if topic and (!$1.tags or !$1.tags.includes("#{topic}"))
				return no

			# TODO: Bring back when we have search again?
			# if q and !$1.title.toLowerCase!.includes(q.toLowerCase!)
			# 	return no

			yes

	def hydrate
		innerHTML = ''
		schedule!
		render!

	def mount
		showFilters? = !!(store.query.level or store.query.duration or store.query.price)

	def reset
		query.level = null
		$level.value = ''
		query.duration = null
		$duration.value = ''
		query.price = null
		$price.value = ''
		imba.commit!

	def render
		<self>
			<header$hero[d:block bg:$light-lavendar a:center w:100vw pt:12 @md:24 pb:7 @sm:7 @md:15 pos:relative]>
				<svg.only-wide.shape[w:80 @md:115 l:2 @md:10 t:17 @md:25 c:$medium-lemony] src="svg/blob5.svg">
				# <svg.only-wide.peep[d:none @md:block l:37 t:62] src="svg/peeps-group-left.svg">
				<svg.only-wide.shape[d:none @md:block w:97 r:13 t:25 transform:matrix(-1, 0, 0, 1, 0, 0) c:$medium-crab-cake] src="svg/blob3.svg">
				# <svg.only-wide.peep[d:none @md:block r:67 t:61] src="svg/peeps-group-right.svg">
				<h1[ta:center fs:3rem] @intersect.out=window.flags.add('mod-sticky-header') @intersect.in=window.flags.remove('mod-sticky-header')> "Scrimba Courses Library"
			<section.all-courses>
				<.permanent-query-container>
					<.topics> for own id, topic of topics
						<a.button.topic.white.selected=(id == query.topic or (id == '' and !query.topic)) @click=(query.topic = id)> topic
					<[d:hflex jc:space-between ai:center mb:2]>
						<.filter-toggle @click=(showFilters? = !showFilters?)>
							<svg[h:7] src="svg/union.svg">
							<p[pl:4]> "Filters"
						<.neutral-button.reset-filters[d:none] [d@lt-sm:hflex p:2 m:2]=showFilters? @click=reset>
							<svg[h:5] src="svg/x.svg">
							<p> "Reset"
				<div.toggled-parent [d:none] [d:vflex @570:hflex]=showFilters?>
					<.toggled-query-container>
						<.content>
							<h4> "Level"
							<.ss-select>
								<select$level.dropdown bind=query.level>
									<option value=''> 'All Levels'
									for own id, name of levels
										<option value=id> name
						<.content>
							<h4> "Duration"
							<.ss-select>
								<select$duration.dropdown bind=query.duration>
									for own id, name of durations
										<option value=id> name
						<.content>
							<h4> "Price"
							<.ss-select>
								<select$price.dropdown bind=query.price>
									for own id,name of prices
										<option value=id> name
					<.neutral-button.reset-filters[d:none @sm:hflex ml@lg:16] @click=reset>
						<svg[h:7] src="svg/x.svg">
						<p[pl:4]> "Reset"

				<.tiles> for course in courses
					<course-tile $key=course.id data=course>